export default "__VITE_ASSET__CqYmQh6E__"